import React, { Component, useEffect, useState } from 'react';
import { getDataGrafico } from '../../../services/service';
import Select from 'react-select';
import LineChart from '../../../Components/highChart/LineChart-v2';
import * as XLSX from 'xlsx';
import { listaColoresChart } from '../../../Components/shared/colores';
import { createLanguageService } from 'typescript';

const firstSelection: any = [{
    "label": "E. Matthei",
    "value": "E. Matthei"
}, {
    "label": "R. Carter",
    "value": "R. Carter"
},{
    "label": "M. Bachelet",
    "value": "M. Bachelet"
},{
    "label": "C. Orrego",
    "value": "C. Orrego"
}
];

const customStyles = {
    option: (provided: any, state: any) => ({
        ...provided,
        padding: 4,
        fontSize: 12,
    }),
    multiValue: (base: any, state: any) => {
        return { ...base, fontSize: 14 };
    },
    singleValue: (provided: any, state: any) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const defaultData = {
    label: '',
    data: [],
    borderColor: '',
    fill: false,
    tension: 0.4,
};

const ChartApi = (props?:{piePagina?:string})  => {
    const idTipoGrafico = 11;
    const nameTitle = "Imagen";


    const [labels, setLabels] = useState([]);
    const [selectOptions, setSelectOptions] = useState([]);
    const [valuesSelected, setValuesSelected] = useState(firstSelection);
    const [currentDatasetItem, setCurrentDatasetItem] = useState([]);
    const [arrayColores, setArrayColores] = useState(listaColoresChart);
    const [apiData, setApiData] = useState([]);
    const [auxCount, setAuxCount] = useState(2);

    const onChangeSelect = async (itemsSelected: any) => {
        const values: string[] = itemsSelected.map((item: any) => item.value);
        if (auxCount < values.length) {
            setAuxCount(auxCount + 1);
            setArrayColores([
                ...arrayColores,
                `rgb(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)})`
            ]);
        } else {
            setAuxCount(auxCount - 1);
        }

        setValuesSelected(itemsSelected);
        if (values.length === 0) {
            setCurrentDatasetItem([]);
            return defaultData;
        }
        const updatedItemsDataset: any = [];
        const dataSet = await arrayDataset();
        let datasetItem: any = [];
        values.forEach((val: any) => {
            datasetItem = dataSet.find((item: any) => item.name === val);
            if (datasetItem) {
                updatedItemsDataset.push(datasetItem);
            }
        });
        setCurrentDatasetItem(updatedItemsDataset);
    }

    const arrayDataset = async (data: any = []) => {
        let arrayItem: any = [], auxArrayToUse: any = [];
        auxArrayToUse = data.length === 0 ? apiData : data;
        await auxArrayToUse.reduce(async (waitExcel: any, dataItem: any) => {
            await waitExcel;
            const dataFormat = await settingData(dataItem);
            arrayItem.push(dataFormat);
        }, Promise.resolve());
        return arrayItem
    }

    const exportExcel = (params: any) => {
        //Creo un nuevo excel
        const wb = XLSX.utils.book_new();

        //Se setean los datos al formato para el excel
        const data = XLSX.utils.json_to_sheet(setDataGraficoForExcel(apiData));

        //Se crea una pagina por cada cada grafico con sus respectivos datos
        XLSX.utils.book_append_sheet(wb, data, 'Imagen Positiva');

        //Se descarga el excel
        XLSX.writeFile(wb, "Data " + "Imagen Positiva" + ".xlsx")
    }

    const setDataGraficoForExcel = (data: any) => {
        let arrayAux: any = [];
        data.map((item: any) => {
            let objAux: any = {};
            for (const key in item) {
                for (const key2 in item[key]) {
                    for (const key3 in item[key][key2]) {
                        let auxObj :any = item[key][key2][key3]
                        if(key3 === nameTitle){
                            objAux['nombre'] = auxObj;
                        } else {
                            objAux["- " + key3.toString() + " -"] = auxObj ? auxObj : '-';
                        }
                    }
                }
            }
            arrayAux.push(objAux);
        });
        const updatedItemsDataset: any = [];
        valuesSelected.forEach((valor: any) => {
            let datasetItem = arrayAux.find((item: any) => item.nombre === valor.value);
            if (datasetItem) {
                updatedItemsDataset.push(datasetItem);
            }
        });
        return updatedItemsDataset;
    }

    const settingData: any = (data: any) => {
        if (data) {
            let response: any = {
                name: '',
                data: []
            };
            let ikey: number = 0
            data.map((item :any) => {
                for (const key in item) {
                    for (const key2 in item[key]) {
                        let auxObj :any = item[key][key2];
                        if(key2 === nameTitle){
                            response.name = auxObj;
                        } else {
                            if(auxObj !== "-"){
                                response.data.push([ikey, Math.round(auxObj)]);
                            }
                            ikey++;
                        }
                    }
                }
            });
            return response;
        } else {
            return 'No Data'
        }
    }

    const getLabels: any = (data: any) => {
        let arrayAux: any = [], arrayAux2: any = [];
        data.map((items:any) => {
            items.map((item:any, index:number) => {
                for (const key in item) {
                    let nomKey :string =  Object.keys(item[key])[0];
                    if( nameTitle !== nomKey){
                        arrayAux.push(nomKey)
                    }
                }
            });
        });
        let labels:any = arrayAux.filter((valor:any, indice:number) => {
            return arrayAux.indexOf(valor) === indice;
        });
        setLabels(labels);
    }

    const getOptionsOfSelect = (data :any) => {
        return data.map((item :any) => {
            for (const key in item) {
                for (const key2 in item[key]) {
                    let aux :any = item[key][key2][nameTitle];
                    if(aux !== undefined){
                        return (
                            {
                                label: aux,
                                value: aux
                            }
                        )
                    }
                }
            }
        })
    }


    useEffect(() => {
        getDataGrafico(idTipoGrafico).then(async (response: any) => {
            let { data, status } = response;
            if (parseInt(status) == 200) {
                let apiData: any = data.data.dataGrafico.Hoja1;
                setApiData(apiData);
                await getLabels(apiData);
                let aux: any = [];
                await arrayDataset(apiData).then(async (funcResponse: any) => {
                    await firstSelection.map((item: any) => {
                        const auxItem: any = funcResponse.find((element: any) => item.label == element.name);
                        aux.push(auxItem);
                    })
                });
                setSelectOptions(await getOptionsOfSelect(apiData));
                setCurrentDatasetItem(aux);
            } else {
                console.error('Error: ' + status);
            }
        });
    }, []);

    return (
        <>
            <div className="shadow p-3 mb-5 bg-body rounded chart-content">
                <Select
                    isMulti
                    placeholder="Seleccionar..."
                    styles={customStyles}
                    closeMenuOnSelect={true}
                    options={selectOptions}
                    onChange={onChangeSelect}
                    value={valuesSelected}
                />
                <div className='mt-3'>
                    <LineChart
                        allData={currentDatasetItem}
                        title="Imagen positiva de figuras políticas"
                        labels={labels}
                        colores={arrayColores}
                        exportExcel={exportExcel}
                        activeButton={valuesSelected.length > 0 ? true : false}
                        onChangeSelect={onChangeSelect}
                    />
                </div>
                <div className='d-flex flex-row-reverse mt-4'>

                    <p style={{ fontSize: 12 }}>{props?.piePagina?props.piePagina:''}</p>
                </div>
            </div>
        </>
    )
}
export default ChartApi;
